module.exports = __webpack_public_path__ + "img/terrace3.f0084d4d.png";